import store from '../../../common/store'
import UserController from '../../user/user.controller'
import getEnv from '@/utils/env'

export default {
  async login (data) {
    await store.dispatch('auth/login', data)
    // Todo Wenn Fehler, dann muß Verarbeitung abbrechen
    UserController.initializeUser()
  },

  getMandatorList () {
    const mandatorId = getEnv('VUE_APP_CARRIER_ID')
    const mode = getEnv('VUE_APP_CARRIER_MODE')
    if (mode === 'multiple') {
      if (mandatorId != null) {
        const mandatorList = store.getters['carrier/getMandatorList'](mandatorId)
        return mandatorList
      } else {
        return []
      }
    } else {
      return []
    }
  },

  isSingleMode () {
    const mode = getEnv('VUE_APP_CARRIER_MODE')
    if (mode === 'single') {
      return true
    } else {
      return false
    }
  },

  getMandator () {
    const mandatorId = getEnv('VUE_APP_CARRIER_ID')
    return mandatorId
  },

  logout () {
    store.dispatch('auth/logout')
    store.dispatch('menu/resetMenu')
    store.dispatch('menu/resetMidwifeFileTabs')
    store.dispatch('menu/resetShortlinks')
    store.commit('right/resetRightsMenu')
    store.dispatch('versioning/resetAllVersion')
  }
}
